import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AllServicesComponent } from '../all-services/all-services.component';

@Component({
  selector: 'app-add-micro-service',
  templateUrl: './add-micro-service.component.html',
  styleUrls: ['./add-micro-service.component.css']
})
export class AddMicroServiceComponent implements OnInit {

  serviceName = ""
  mircServiceName = ""
  microSeriveCost = ""
  serviceImage = ""
  constructor(public dialogRef: MatDialogRef<AllServicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,){}

  ngOnInit(){
    this.serviceName = this.data.name
  }

  
  uploadServiceImage(e:any){
    console.log(e.target.value)
    this.serviceImage = e.target.files[0]
  }

  addService(){
    let data = {
      name : this.mircServiceName,
      cost : this.microSeriveCost,
      image : this.serviceImage
    }
    console.log(data)
    this.dialogRef.close(data)
  }
}
